// assets/src/jsx/components/Home/FeatureHighlights.jsx
import React from 'react';
import IntlMessages from 'appUtil/IntlMessages';

const FEATURES = [
    {icon: 'fa-database', titleId: 'home.features.schemas', descId: 'home.features.schemas.desc'},
    {icon: 'fa-link-simple', titleId: 'home.features.dataViews', descId: 'home.features.dataViews.desc'},
    {icon: 'fa-file-export', titleId: 'home.features.apis', descId: 'home.features.apis.desc'},
];

const FeatureHighlights = () => (
    <div className="gdb-home-panel gdb-home-features">
        <div className="gdb-home-panel__label"><IntlMessages id="home.features.title"/></div>
        <div className="gdb-home-features__grid">
            {FEATURES.map((f) => (
                <div className="gdb-home-feature" key={f.titleId}>
                    <i className={`far ${f.icon} gdb-home-feature__icon`} aria-hidden="true"/>
                    <b><IntlMessages id={f.titleId}/></b>
                    <span><IntlMessages id={f.descId}/></span>
                </div>
            ))}
        </div>
    </div>
);

export default FeatureHighlights;
